<script lang="ts">
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import { fade } from 'svelte/transition';
	import Button from '../Button/Button.svelte';
	import SubtitledIconButton from '../Button/SubtitledIconButton.svelte';
	import PlayIcon from '../Icon/PlayIcon.svelte';
	export let title: string;
	export let subtitle: string;
	export let buttonText: string = '';
	export let href: string = '';

	export let additionalClass = '';

	const { t } = getTranslate();
</script>

<div
	transition:fade|local
	class={classes(additionalClass, 'flex flex-col gap-4 self-end px-0 min-[500px]:px-11 md:px-0')}
>
	<div class="px-11 xs:px-0">
		<h1 class="text-5xl lg:text-5xl 2xl:text-7xl uppercase">
			{title}
		</h1>
		<h2 class="text-lg">{subtitle}</h2>

		<div class="flex flex-row items-center gap-11 w-full justify-start pt-11">
			<SubtitledIconButton on:showOverlay subtitle="Trailer"><PlayIcon /></SubtitledIconButton>
			<a class="h-12 w-1/2 min-w-[8rem] max-w-[24.3125rem] !mr-4" {href}>
				<Button
					additionalClass="!bg-black !px-[10%] xl:!px-[10%] hover:!bg-purple text-white h-12 w-full whitespace-nowrap uppercase"
					>{$t(buttonText)}</Button
				>
			</a>
		</div>
	</div>
</div>
